<template>
  <Layout @componentKey="gotRefresh" @currentPage="currentPage" :hasPagination="true" :hasBreadcrumbs="true" :amount="amount.aantal" :amountToShow="amountToShow" :openModalHandler="openModalHandler">
    <div class="content">
      <div class="page-content" ref="tableContent">
        <MainTitle :title="this.$router.currentRoute.name"  />
        <RawMatTable @selectedAmount="gotAmountToShow" @selectedRow="gotMat" :rawMats="rawMats" :totalItems="amount.aantal" @sorting="gotSorting" @refresh="gotRefresh" />
      </div>
      <div class="sidebar">
        <TableAction :hasButton="true" @clickedButton="gotClick" title="Add Raw Material"/>
        <TableDetail v-if="this.selectedMat" height="44" :details="this.selectedMat" />
        <TableDetailComment v-if="this.selectedMat" height="20" :details="this.selectedMat" @refresh="gotRefreshPageData"/>
      </div>
    </div>
  </Layout>
</template>
<script>
// @ is an alias to /src
import Layout from "@/layouts/Dashboard";
import RawMatTable from "@/components/TblRawMat";
import TableAction from "@/components/TableAction";
import TableDetail from "@/components/TblRawMatDetail";
import TableDetailComment from "@/components/TblDetailComment";
import MainTitle from "@/components/base/MainTitle";

export default {
  name: "management-rawmaterials",
  props: {
    compKey: Number
  },
  computed: {
    maxRows: function () {
      let heightContent = this.$refs.tableContent.clientHeight;
      let heightSingleRow = 76

      return Math.ceil(heightContent / heightSingleRow) - 2
    },
    userDetails() {
      return this.$store.state.userDetails
    }
  },
  data () {
    return {
      rawMats: [],
      amount: 0,
      selectedMat: null,
      pagina: 1,
      openModalHandler: false,
      sortingOn: "rawmaterialID",
      isAscending: true,
      amountToShow: 8
    }
  },
  components: {
    Layout,
    RawMatTable, 
    MainTitle, 
    TableAction,
    TableDetail,
    TableDetailComment 
  },
  mounted() {
    this.amountToShow = this.maxRows
    this.getData()
  },
  methods: {
    gotAmountToShow(val) {
      if(val == 9) {
        this.amountToShow = this.maxRows
      } else {
        this.amountToShow = parseInt(val)
      }
      this.pagina = Math.ceil(this.amount.aantal / parseInt(val))
      this.getData()
    },
    getData() {
      var that = this
      let offset = this.pagina != 1 ? (this.pagina * this.amountToShow) - this.amountToShow : 0
      let asc = this.isAscending ? "A" : "D"
      this.$http.get(this.$endpoint + 'management/rawmaterials/' + this.sortingOn + '/' + asc + '/' + this.amountToShow + '/' + offset)
      .then(response => {
        that.amount = response.data.pop()
        that.rawMats = response.data
        that.selectedMat = null

        switch(this.sortingOn) {
          case 'rawmaterialID':
            if(this.isAscending) {
              that.rawMats.sort((a, b) => (a.rawMaterialID > b.rawMaterialID) ? 1 : -1)
            } else {
              that.rawMats.sort((a, b) => (a.rawMaterialID < b.rawMaterialID) ? 1 : -1)
            }
            break;
          case 'ref':
            if(this.isAscending) {
              that.rawMats.sort((a, b) => (a.ref > b.ref) ? 1 : -1)
            } else {
              that.rawMats.sort((a, b) => (a.ref < b.ref) ? 1 : -1)
            }
            break;
        }
      })
      .catch(error => {
        if (error.response.status === 401) {
          this.$store
          .dispatch("logout")
          .then(() => this.$router.push("/login"))
          .catch(err => console.log(err));
        } else {
          that.$swal(
            'Oops that went wrong?',
            `Please contact the admin with the following info: ${ error }`,
            'error'
          );
        }
      })
    },
    currentPage(page) {
      this.pagina = page // someValue
    },
    gotSorting(sort) {
      this.isAscending = sort.asc
      this.sortingOn = sort.on
      this.getData()
    },
    gotMat(mat) {
      this.selectedMat = mat // someValue
    },
    gotClick(val) {
      this.openModalHandler = !this.openModalHandler;
    },
    gotRefresh(val) {
      this.pagina = 1
      this.amount = 0
      this.getData()
    },
    gotRefreshPageData(val) {
      this.getData()
    }
  },
  watch: {
    pagina: function (val) {
      this.getData()
    },
    amount: function (newVal, oldVal) {
      if(newVal.aantal != oldVal && newVal.aantal != oldVal.aantal && oldVal != 0) {
        this.getData()
      }
    },
  }
};
</script>
<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/content.scss";
@import "@/style/components/sidebar.scss";
/* 
.sidebar {
  background-color: red;
} */
</style>;
